import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { DelegateSignerDto } from '@models/users/delegation.dto';
import { SubscriberDto } from '@models/users/subscriber.dto';
import { AccountService } from '@services/account.service';
import {
  FormatType,
  NgWhiteboardComponent,
  WhiteboardElement,
} from 'ng-whiteboard';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'ebs-delegation-confirm',
  templateUrl: './delegation-confirm.component.html',
  styleUrls: ['./delegation-confirm.component.scss'],
})
export class DelegationConfirmComponent implements OnInit {
  confirmFormGroup!: FormGroup;

  availableFonts = [
    'bastliga',
    'broetown',
    'calvin-fallen',
    'corinthiago',
    'lihataja',
    'qwigley',
    'starlights',
    'washington',
  ];
  selectedFont: string = 'bastliga';

  public signer: DelegateSignerDto = {
    delegateName: '',
    delegateRole: '',
    showSign: true,
    fontFamily: 'bastliga',
    subscriptionDate: new Date(),
    subscriptionPlace: '',
  };

  constructor(
    public ref: DynamicDialogRef,
    public dialogService: DialogService,
    private accountService: AccountService,
  ) {
    this.confirmFormGroup = new FormGroup({
      subscriptionPlace: new FormControl<string>(
        '',
        Validators.compose([Validators.required]),
      ),
      showSign: new FormControl<boolean>(
        true,
        Validators.compose([Validators.required]),
      ),
    });
  }
  ngOnInit(): void {
    let delegate = <SubscriberDto>this.accountService.user;
    this.signer.delegateName = `${delegate.name} ${delegate.lastName}`;
    this.signer.delegateRole = delegate.role;
    this.signer.subscriptionPlace = delegate.headquarter;
    this.signer.showSign = true;
  }

  onSignWhiteboardSave(event: string) {}

  confirm() {
    this.ref.close({
      signer: this.signer,
    });
  }

  cancel() {
    this.ref.close(false);
  }
}
